import { z, ZodString } from "zod";
import { errorMessage } from "../helper/errorMessage";
import { regex } from "../helper/regex";

export const otpValidator: ZodString = z
  .string()
  .min(1, { message: errorMessage("required-field", { field: "code" }) })
  .regex(regex.alphanumeric, {
    message: errorMessage("invalid-value", { field: "code" }),
  });
